import React, { useState } from "react";
import { useSelector } from "react-redux";
import LanguageToggle from "./language-toggle/LanguageToggle";
import { DEFAULT_LANGUAGE, LOCAL_STORAGE_KEY, SUPPORTED_LANGUAGES } from "utilities/Constant";
import { useGetFeatureFlagsQuery } from "services/common/featureFlagService";
import { selectHasLoans } from "features/preferredLanguageSlice";

interface PreferredLanguageProps {
  readonly isMobile?: boolean;
}

const isSupportedLanguage = (value: string): boolean => {
  return SUPPORTED_LANGUAGES.includes(value);
};

const setLocalStorage = (key: string, value: string): void => {
  window.localStorage.setItem(key, value);
};

const getLocalStorage = (key: string): string | null => {
  return window.localStorage.getItem(key);
};

const getInitialLanguage = (): string => {
  const savedLanguage = getLocalStorage(LOCAL_STORAGE_KEY);

  if (savedLanguage && isSupportedLanguage(savedLanguage)) {
    return savedLanguage;
  }

  setLocalStorage(LOCAL_STORAGE_KEY, DEFAULT_LANGUAGE);
  return DEFAULT_LANGUAGE;
};

const PreferredLanguage: React.FC<PreferredLanguageProps> = ({ isMobile = false }) => {
  const { data: featureFlag } = useGetFeatureFlagsQuery();
  const [userLanguage, setUserLanguage] = useState<string>(getInitialLanguage);
  const hasLoans = useSelector(selectHasLoans);

  if (!featureFlag?.preferredLanguageEnabled) {
    return null;
  }

  const handleLanguageChange = (value: string) => {
    setUserLanguage(value);
    setLocalStorage(LOCAL_STORAGE_KEY, value);
  };

  return (
    <div className="preferred-language">
      <LanguageToggle value={userLanguage} onChange={handleLanguageChange} options={SUPPORTED_LANGUAGES} isMobile={isMobile} disabled={!!hasLoans} />
    </div>
  );
};

export default PreferredLanguage;
